import { DatePickerWithRange } from '../DatePickerWithRange'

import { DatePickerTagControl } from './DatePickerTagControl'
import { useDatePickerTag } from './useDatePickerTag.hooks'

function DatePickerTag({ controlProps, endDate, startDate, ...restProps }) {
  const { handleChange, handleChangeRange, handleClear } =
    useDatePickerTag(restProps)

  return (
    <DatePickerWithRange
      {...controlProps}
      Input={DatePickerTagControl}
      endValue={endDate}
      startValue={startDate}
      value={startDate}
      onChange={handleChange}
      onChangeRange={handleChangeRange}
      onClear={handleClear}
    />
  )
}

export default DatePickerTag
